<template>
  <input
    ref="autocomplete"
    type="text"
    class="google-location-editor"
    v-model="value"
    @focus="onFocus"
    @blur="onBlur"
  />
</template>

<script>
export default {
  name: 'GoogleLocationEditor',
  data() {
    return {
      value: '',
      autocomplete: null,
      selectedPlace: null,
    };
  },
  methods: {
    getValue() {
      return this.value;
    },

    initAutocomplete() {
      if (window.google) {
        this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {
          types: ['geocode'],
          fields: ['formatted_address', 'geometry', 'name', 'place_id'],
        });

        this.autocomplete.addListener('place_changed', this.onPlaceChanged);
      }
    },

    onPlaceChanged() {
      const place = this.autocomplete.getPlace();

      if (!place.geometry) {
        return;
      }

      this.selectedPlace = place;
      this.value = place.formatted_address;

      this.params.api.stopEditing();
    },

    onFocus() {
      if (!this.autocomplete) {
        this.initAutocomplete();
      }
    },

    onBlur() {
      setTimeout(() => {
        // If no place was selected but text was entered, keep the text, since we allow custom locations
        if (!this.selectedPlace && this.value && this.params && this.params.api) {
          this.params.api.stopEditing();
        }
      }, 200);
    },
  },
  created() {
    this.value = this.params.value || '';
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.autocomplete.focus();
    });
  },
  beforeDestroy() {
    if (this.autocomplete) {
      google.maps.event.clearInstanceListeners(this.autocomplete);
    }
  },
};
</script>

<style lang="scss" scoped>
.google-location-editor {
  width: 100%;
  height: 100%;
  padding: 4px 8px;
  box-sizing: border-box;
  border: none;
  outline: none;
  font-size: 12px;

  &:focus {
    outline: none;
  }
}
</style>
